"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/input-number/style/css");

var _inputNumber = _interopRequireDefault(require("antd/es/input-number"));

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/form/style/css");

var _form = _interopRequireDefault(require("antd/es/form"));

var _react = _interopRequireWildcard(require("react"));

var _ = _interopRequireWildcard(require("lodash"));

var _uuid = _interopRequireDefault(require("uuid"));

var _icons = require("@ant-design/icons");

require("../activity.scss");

var _CategoryOption = _interopRequireDefault(require("./CategoryOption"));

var _QuizOption = _interopRequireDefault(require("./QuizOption"));

var _OptionFeedbackItem = _interopRequireDefault(require("../feedback/OptionFeedbackItem"));

var _ActivityFormContainer = require("../ActivityFormContainer");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Item
} = _form.default;
const defaultFeedback = {
  uuid: '',
  title: '',
  text: '',
  min: undefined,
  max: undefined,
  isOverallFeedback: false
};
const itemStyle = {
  width: '100%',
  marginBottom: '10px',
  marginTop: '10px'
};

class OptionItem extends _react.Component {
  constructor() {
    super(...arguments);

    this.onTextChange = e => {
      const {
        option,
        updateOption
      } = this.props;
      option.text = e.target.value;
      updateOption(option);
    };

    this.onPointsChange = value => {
      const {
        option,
        updateOption
      } = this.props;
      option.points = Number(value);
      updateOption(option);
    };

    this.onCorrectChange = e => {
      const {
        option,
        updateOption
      } = this.props;
      option.isCorrect = e.target.checked;
      updateOption(option);
    };

    this.setPoints = value => {
      const {
        option,
        updateOption
      } = this.props;
      option.points = value;
      updateOption(option);
    };

    this.onMoveUpClick = e => {
      const {
        moveUp
      } = this.props;
      e.preventDefault();
      moveUp();
    };

    this.onMoveDownClick = e => {
      const {
        moveDown
      } = this.props;
      e.preventDefault();
      moveDown();
    };

    this.updateFeedback = f => {
      const {
        option,
        updateOption
      } = this.props;
      option.feedback = f;
      updateOption(option);
    };

    this.addFeedback = () => {
      const {
        option,
        updateOption
      } = this.props;
      option.feedback = _.cloneDeep(defaultFeedback);
      option.feedback.uuid = (0, _uuid.default)();
      updateOption(option);
    };

    this.removeFeedback = () => {
      const {
        option,
        updateOption
      } = this.props;
      option.feedback = undefined;
      updateOption(option);
    };
  }

  render() {
    const {
      option,
      typeId,
      disabled
    } = this.props;
    const {
      text,
      points,
      uuid,
      feedback,
      id
    } = option;
    let item;

    switch (typeId) {
      case _ActivityFormContainer.Type.quiz:
        item = /*#__PURE__*/_react.default.createElement(_QuizOption.default, {
          disabled: disabled,
          option: option,
          onTextChange: this.onTextChange,
          onPointsChange: this.onPointsChange,
          onCorrectChange: this.onCorrectChange,
          updateFeedback: this.updateFeedback,
          addFeedback: this.addFeedback,
          removeFeedback: this.removeFeedback
        });
        break;

      case _ActivityFormContainer.Type.category:
        item = /*#__PURE__*/_react.default.createElement(_CategoryOption.default, {
          disabled: disabled,
          option: option,
          onTextChange: this.onTextChange,
          setPoints: this.setPoints
        });
        break;

      case _ActivityFormContainer.Type.ranking:
        item = /*#__PURE__*/_react.default.createElement("div", {
          className: "option-container"
        }, /*#__PURE__*/_react.default.createElement(_input.default, {
          spellCheck: true,
          disabled: disabled,
          placeholder: "Option text",
          value: text,
          onChange: this.onTextChange,
          style: {
            width: '100%'
          }
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "option-props"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "option-prop"
        }, "Point Value", ' ', /*#__PURE__*/_react.default.createElement(_inputNumber.default, {
          disabled: disabled,
          value: points,
          min: 0,
          onChange: this.onPointsChange
        })), /*#__PURE__*/_react.default.createElement(_button.default, {
          disabled: disabled,
          onClick: this.onMoveUpClick
        }, /*#__PURE__*/_react.default.createElement(_icons.UpOutlined, null)), /*#__PURE__*/_react.default.createElement(_button.default, {
          disabled: disabled,
          onClick: this.onMoveDownClick
        }, /*#__PURE__*/_react.default.createElement(_icons.DownOutlined, null))));
        break;

      case _ActivityFormContainer.Type.category_no_answer:
      case _ActivityFormContainer.Type.screener:
        item = /*#__PURE__*/_react.default.createElement("div", {
          className: "option-container"
        }, /*#__PURE__*/_react.default.createElement(_input.default, {
          spellCheck: true,
          disabled: disabled,
          placeholder: "Option text",
          value: text,
          onChange: this.onTextChange,
          style: {
            width: '100%'
          }
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "option-props"
        }, /*#__PURE__*/_react.default.createElement(Item, {
          key: `input-number-option-${id}`
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "option-prop"
        }, "Point Value", ' ', /*#__PURE__*/_react.default.createElement(_inputNumber.default, {
          disabled: disabled,
          value: points,
          min: 0,
          onChange: this.onPointsChange
        })))));
        break;

      case _ActivityFormContainer.Type.goals:
        item = /*#__PURE__*/_react.default.createElement("div", {
          className: "option-container"
        }, /*#__PURE__*/_react.default.createElement(_input.default, {
          spellCheck: true,
          disabled: disabled,
          placeholder: "Option text",
          value: text,
          onChange: this.onTextChange,
          style: {
            width: '100%'
          }
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "option-props"
        }, /*#__PURE__*/_react.default.createElement(_OptionFeedbackItem.default, {
          type: _ActivityFormContainer.Type.goals,
          disabled: disabled,
          feedback: feedback,
          option: option,
          updateFeedback: this.updateFeedback,
          addFeedback: this.addFeedback,
          removeFeedback: this.removeFeedback
        })));
        break;

      default:
        item = /*#__PURE__*/_react.default.createElement(_input.default, {
          spellCheck: true,
          disabled: disabled,
          placeholder: "Option text",
          value: text,
          onChange: this.onTextChange,
          style: {
            width: '80%'
          }
        });
        break;
    }

    return /*#__PURE__*/_react.default.createElement(Item, {
      required: false,
      key: `option-${id || uuid}`,
      name: `options-${id || uuid}`,
      style: itemStyle,
      initialValue: text
    }, item);
  }

}

var _default = OptionItem;
exports.default = _default;